import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import {connect}  from  "react-redux";
import axios from "axios";
import { useLocation } from 'react-router-dom'
import {BeatLoader} from 'react-spinners';
import {css} from "@emotion/core";
import { user_activities } from '../helpers/utils.js';
import ModalD from "react-awesome-modal";
import DatePicker from "react-datepicker";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import * as moment from "moment";
import IdleTimer from 'react-idle-timer'
const { tableau } = window;
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    color: white;
    text-align:center;
`;
const d = new Date();
var year = d.getFullYear();
var month = d.getMonth();
var day = d.getDate();
function convertToCSV(json) { console.log("ggggggggg"); console.log(json);
      const items = json;
      const replacer = (key, value) => (value === null ? '' : value); // Replace null values with empty strings
      const header = Object.keys(items[0]);
      const csv = [
        header.join(','), // Create CSV header row
        ...items.map((row) => header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(',')), // Create CSV data rows
      ].join('\r\n');

      return csv;
    }

    function downloadCSV(csv, filename) {
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) {
        // For IE and Edge
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }
    const extractKeyValue = (array, ...keysToExtract) => {
      return array.map((obj) => {
        const extractedData = {};
        keysToExtract.forEach((key) => {
          extractedData[key] = obj[key];
        });
        return extractedData;
      });
    };
class LoungeReportAPIQA extends Component{
    constructor(props) {
        super(props);
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        const token = localStorage.usertoken;
        const tokenPermission = localStorage.userPermission;
        let loggedIn = true;
        if (token == null) {
            loggedIn = false;
        }
        this.state = {
            loggedIn,
            isTimedOut: false,
            reportPermissionsArray:[],
            tableau_worksheet:[],
            project_name:"",
            loading: true,
            showForm:false,
            isMsg:false,
            underlyingData: [],
            startDate: new Date(),
            endDate: new Date(year, month + 3, day),
            _notificationSystem: null,
            visitType:"",
            no_of_visits:"",
            campaign_data:[],
            visit_count:"",
            customers_count:"",
            selectedMarks: [],
            filterInfo:{},
            marksData: {},
            selectedMarksData: {},
            isVizConnected: '',
            visit_type_lists:[],
            selected_visit_type:"",
            customers_se:"",
            isOnline: navigator.onLine,
            keyValuesDataPost:[],
            batchSize: 2,
            batchStart:'',
            batchEnd:'',
            show_count: false,
            loading1:false,
            api_status: 'Success',
            api_report:[]
        }
    }
     _onAction(e) {
         console.log('user did something', this.idleTimer.getRemainingTime())
    }

    _onActive(e) {
        // console.log('user is active', e)
         console.log('time remaining', this.idleTimer.getRemainingTime())
        var remain_time = this.idleTimer.getRemainingTime();
        if(remain_time==0) {
            this.update_idle_token();
            localStorage.removeItem("usertoken");
            localStorage.removeItem("userPermission");
            this.setState({
                loggedIn: false
            });
            window.location.href = "/";
        }
    }

    _onIdle(e) {
         console.log('user is idle', e)
        // console.log('last active', this.idleTimer.getLastActiveTime())
        // console.log("delete token")
        this.update_idle_token();
    }
    update_idle_token(){
        const valid_token = localStorage.usertoken;
        const decoded_valid_token = jwt_decode(valid_token);
        axios.post(config.get('API_URL')+'/users/update-token', {
                user_id: decoded_valid_token._id,
                user_token: localStorage.usertoken,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
            })
            .then(response => {
                console.log("Timeout");
                localStorage.removeItem("usertoken");
                localStorage.removeItem("userPermission");
                this.setState({
                    loggedIn: false
                });
                alert("Session Has been expired.");
                window.location.href = "/";
            })
            .catch(err => {
                console.log(err)
            })
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentWillMount() {
        this.props.currentMenu("unipaynext");
    }

    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        //console.log(decoded);

        this.get_trusted_token(decoded.tableau_username);
        this.isTokenExpired(localStorage.usertoken);
        this.get_visit_type()
        this.checkConnectionInterval = setInterval(this.checkConnectionStatus, 300000);
        window.addEventListener('online', this.handleOnline);
        window.addEventListener('offline', this.handleOffline);
    }
    componentWillUnmount() {
    // Clean up when component is unmounted
        clearInterval(this.checkConnectionInterval);
        window.removeEventListener('online', this.handleOnline);
        window.removeEventListener('offline', this.handleOffline);
    }
    componentDidUpdate(e) {
        this.isTokenExpired(localStorage.usertoken);
        this.isValidToken();

    }
    handleOnline = () => {
        this.setState({ isOnline: true });
    };

    handleOffline = () => {
        console.log("offline");
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            isOnline: false,
            loggedIn: false
        });
    };

    isValidToken(){
        const valid_token = localStorage.usertoken;
        const decoded_valid_token = jwt_decode(valid_token);
        axios.post(config.get('API_URL')+'/users/verify-token', {
                user_id: decoded_valid_token._id,
                user_token: localStorage.usertoken,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
            })
            .then(response => {
                try {
                    if (response.data.status=='error') {
                        this.handleNotificationClick("tc", 3, "Session Has been expired.");
                        setTimeout( function(){
                            localStorage.removeItem("usertoken");
                            localStorage.removeItem("userPermission");
                            this.setState({
                                loggedIn: false
                            });
                            window.location.href = "/";
                        }.bind(this)  , 1000 );
                        // Try Now
                    }

                    if(response.data.password_exp=='first_login'){
                        if(decoded_valid_token.authType!='Google') {
                            if (this.props.location.pathname != '/admin/user-profile') {
                                this.handleNotificationClick("tc", 3, "Your Password Has been expired. Please Change your Password");
                                setTimeout(function () {
                                    window.location.href = "/admin/user-profile";
                                }.bind(this), 2000);
                            }
                        }
                    }
                } catch (err) {
                    console.log("expired check failed!");
                }

            })
            .catch(err => {
                console.log(err)
            })
    }
    isTokenExpired = token => {
        try {
            const decoded = jwt_decode(token);
            if (decoded.exp < Date.now() / 1000) {
                localStorage.removeItem("usertoken");
                localStorage.removeItem("userPermission");
                this.setState({
                    loggedIn: false
                });
                window.location.href = "/";
            }
        } catch (err) {
            console.log("expired check failed!");
        }
    };
    checkConnectionStatus = () => {

    if (this.viz) {
         var sheet = this.viz.getWorkbook().getActiveSheet().getWorksheets().get("Visit-Organization");
	       // If the active sheet is not a dashboard, then you can just enter:
	       // viz.getWorkbook().getActiveSheet();
         var options = {
            maxRows: 0, // Max rows to return. Use 0 to return all rows
            ignoreAliases: true,
            ignoreSelection: false,
            includeAllColumns: false
          };
          console.log(sheet);
          if(sheet) {
             console.log("find the sheet")
          }
          else {
              console.log("worksheet data null")
          }
           console.log("bbbbbbbbbbbbb");
          sheet.getUnderlyingDataAsync(options).then(function(t){
              console.log("uuuuuuuuuuuuuuu");

              });

    }
//    const sheet1 = this.viz.getWorkbook().getActiveSheet();
//    console.log(sheet1);
//    if(sheet1){
//     console.log("connected");
//     console.log(new Date().toLocaleString())
//    } else {
//      console.log("connection lost");
//      console.log(new Date().toLocaleString())
//    }
//    if (this.viz) {
//         console.log("connected viz");
//    }
//    else {
//         console.log("connection lost viz");
//    }
  };
    get_trusted_token(tableau_username){
        if(tableau_username==='' || tableau_username===null || tableau_username==='null'){
            alert("Your account is not mapped with tableau user.");
            this.setState({
               loading:false,
            });
            return false;
        }

        axios.get(config.get('API_URL')+'/tableau/get-trusted-token/',

       {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                tableau_username: tableau_username,
            }
        }).then(response => {
            //console.log(response.data);

            if(response.data.data!== undefined) {
                this.get_tableau_report(this.props.match.params.id);

                this.setState({
                    tableau_token:response.data.data,
                    tableau_server_url: response.data.server_url,
                    token_error:false,
                    loading:false,
                });
            } else {
                alert("Error while generating token");
                //this.get_tableau_report(this.props.match.params.id);
                //console.log("dddddddd", response.data.error.error)
                this.setState({
                    token_error:true,
                    loading:false,
                    tableau_token:response.data.data,
                    tableau_server_url: response.data.server_url

                });
            }


        }).catch(error => {
          console.log(error);
        });
    }
    get_tableau_report(view_id){
         axios.post(config.get('API_URL')+'/tableau/get-tableau-report/',
         {
            view_id:view_id
         },
         {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {
            this.setState({
                tableau_report_name: response.data.view_name,
                tableau_report_link: response.data.url,
                workbook_name: response.data.project_name,
                workbook_kpi_id: response.data.project_id,
                worksheet_name: response.data.workbook_name,
                worksheet_kpi_id: response.data.workbook_id,
            })

            this.initTableauViz()

        }).catch( err => {
            console.log(err);
        });
    }
    initTableauViz = () => {
    let reportUrl = this.state.tableau_server_url+"/trusted/"+this.state.tableau_token+this.state.tableau_report_link
    const vizDiv = document.getElementById('tableauViz');
    const vizURL = reportUrl;

    const options = {
      width: '100%',
      height: '600px',
      hideTabs: true,
      hideToolbar: true,
      onFirstInteractive: this.handleFirstInteractive,
    };

    // Create a new Tableau Viz object
    const viz = new tableau.Viz(vizDiv, vizURL, options);
    this.viz = viz;
  };

  getUnderlyingData(e) {
    var that = this;
    // Call the getUnderlyingDataAsync method on the viz object
    var keyValuesData = [];
    if (this.viz) {
         var sheet = this.viz.getWorkbook().getActiveSheet().getWorksheets().get("Visit-Organization");
	       // If the active sheet is not a dashboard, then you can just enter:
	       // viz.getWorkbook().getActiveSheet();
         var options = {
            maxRows: 0, // Max rows to return. Use 0 to return all rows
            ignoreAliases: true,
            ignoreSelection: false,
            includeAllColumns: false
          };
          console.log(sheet);
          if(sheet) {
             console.log("find the sheet")
          }
          else {
              console.log("worksheet data null")
          }
          sheet.getUnderlyingDataAsync(options).then(function(t){
              var columns = t.getColumns();
              var dataRows = t.getData();
              console.log(columns);
              //console.log(dataRows);
                 for (var i = 0; i < dataRows.length; i++) {
                      var row = dataRows[i];
                      var keyValueRow = {};

                      for (var j = 0; j < columns.length; j++) {
                        var fieldName = columns[j].getFieldName();
                        var fieldValue = row[j].value;

                        keyValueRow[fieldName] = fieldValue;
                      }

                      keyValuesData.push(keyValueRow);
                    }
                  console.log(keyValuesData);
                  const csv = convertToCSV(keyValuesData);
                  const filename = 'lounge-report.csv';
                  downloadCSV(csv, filename);
                  that.setState({
                    underlyingData:keyValuesData
                  })
              });

    }
  }
  closeUploadModal(){
    this.setState({
        user_upload: false,
        showForm:false,
        isMsg:false,
        startDate: new Date(),
        endDate: new Date(year, month + 3, day),
        visitType:"",
        no_of_visits:""
    })
  }
   toggleNewUserUpload(e){
        this.setState({
            user_upload: true
        })
        var that = this;
    // Call the getUnderlyingDataAsync method on the viz object
    var keyValuesData = [];
    var keyValuesData1 = [];
    var keyValuesDataPost = [];
    if (this.viz) {
         var sheet = this.viz.getWorkbook().getActiveSheet().getWorksheets().get("Visit-Organization");
	       // If the active sheet is not a dashboard, then you can just enter:
	       // viz.getWorkbook().getActiveSheet();
         var options = {
            maxRows: 0, // Max rows to return. Use 0 to return all rows
            ignoreAliases: true,
            ignoreSelection: false,
            includeAllColumns: false
          };
          console.log(sheet);
          if(sheet) {
             console.log("find the sheet")
          }
          else {
              console.log("worksheet data null")
          }
          sheet.getUnderlyingDataAsync(options).then(function(t){
              var columns = t.getColumns();
              var dataRows = t.getData();
              console.log(columns);
              //console.log(dataRows);
                 for (var i = 0; i < dataRows.length; i++) {
                      var row = dataRows[i];
                      var keyValueRow = {};
                       var keyValueRowPostData = {};
                      for (var j = 0; j < columns.length; j++) {
                        var fieldName = columns[j].getFieldName();
                        var fieldValue = row[j].value;

                        keyValueRow[fieldName] = fieldValue;
                        if(fieldName=="memberId" || fieldName=="sponsorId")
                        {
                            keyValueRowPostData[fieldName] = fieldValue;
                        }
                      }

                      keyValuesData.push(keyValueRow);
                      keyValuesDataPost.push(keyValueRowPostData);
                    }

				    var uniqueObjectsByMemberId = {};
                        keyValuesData.forEach(item => {
                          const memberId = item.memberId;
                          if (!uniqueObjectsByMemberId[memberId]) {
                            uniqueObjectsByMemberId[memberId] = item;
                          }
                        });
                    keyValuesData = Object.values(uniqueObjectsByMemberId);
				    //keyValuesData = Array.from(new Set(keyValuesData.map(item => item.memberId)));
				    //keyValuesDataPost = Array.from(new Set(keyValuesDataPost.map(item => item.memberId)));
				    var uniqueObjectsByMemberId1 = {};
                        keyValuesDataPost.forEach(item1 => {
                          const memberId1 = item1.memberId;
                          if (!uniqueObjectsByMemberId1[memberId1]) {
                            uniqueObjectsByMemberId1[memberId1] = item1;
                          }
                        });
                    keyValuesDataPost = Object.values(uniqueObjectsByMemberId1);
                  const extractedDataArray = extractKeyValue(keyValuesData, "Mobile Hash");
                  console.log(extractedDataArray);
                   console.log(keyValuesData);
				    console.log(keyValuesDataPost);
                  that.setState({
                    underlyingData:keyValuesData,
                    campaign_data: extractedDataArray,
                    keyValuesDataPost: keyValuesDataPost
                  })
              });

              //customers

               var sheet1 = this.viz.getWorkbook().getActiveSheet().getWorksheets().get("Customers");
	       // If the active sheet is not a dashboard, then you can just enter:
	       // viz.getWorkbook().getActiveSheet();
         var options1 = {
            maxRows: 0, // Max rows to return. Use 0 to return all rows
            ignoreAliases: true,
            ignoreSelection: false,
            includeAllColumns: false
          };
          console.log(sheet1);
          if(sheet1) {
             console.log("find the sheet")
          }
          else {
              console.log("worksheet data null")
          }
          sheet1.getUnderlyingDataAsync(options1).then(function(t){
              var columns1 = t.getColumns();
              var dataRows1 = t.getData();
			  console.log(dataRows1.length);
			  var customers_count = dataRows1.length;
			  if(customers_count<1) {
			    customers_count = "";
			  }
			  var customers_se = "";
			  if(customers_count<1) {
			    customers_se = "";
			  } else if(customers_count>1) {
			    customers_se = "customers selected";
			  } else {
			    customers_se = "customer selected";
			  }
              console.log(columns1);
              for (var i1 = 0; i1 < dataRows1.length; i1++) {
                      var row1 = dataRows1[i1];
                      var keyValueRow1 = {};

                      for (var j1 = 0; j1 < columns1.length; j1++) {
                        var fieldName1 = columns1[j1].getFieldName();
                        var fieldValue1 = row1[j1].value;

                        keyValueRow1[fieldName1] = fieldValue1;
                      }

                      keyValuesData1.push(keyValueRow1);
                    }
                    var lookup = {};
                    var items = keyValuesData1;
                    var result = [];

                    for (var item, i = 0; item = items[i++];) {
                      var name = item["Member Id"];

                      if (!(name in lookup)) {
                        lookup[name] = 1;
                        result.push(name);
                      }
                    }
                    console.log(result);
                  that.setState({
                    customers_count:result.length,
                    customers_se:customers_se
                  })
              });

              //customers

               var sheet2 = this.viz.getWorkbook().getActiveSheet().getWorksheets().get("Visits");
	       // If the active sheet is not a dashboard, then you can just enter:
	       // viz.getWorkbook().getActiveSheet();
         var options2 = {
            maxRows: 0, // Max rows to return. Use 0 to return all rows
            ignoreAliases: true,
            ignoreSelection: false,
            includeAllColumns: false
          };
          console.log(sheet2);
          if(sheet2) {
             console.log("find the sheet")
          }
          else {
              console.log("worksheet data null")
          }
          sheet2.getUnderlyingDataAsync(options2).then(function(t){
              var columns2 = t.getColumns();
              var dataRows2 = t.getData();
			  console.log(dataRows2.length);
			  var visit_count = dataRows2.length
              console.log(columns2);
              //console.log(dataRows1);
                  that.setState({
                    visit_count:visit_count
                  })
              });
    }
    }
    changeVal=event=>{

    };
    ChangeEligibility(e) {
        this.setState({
            showForm: !this.state.showForm,
        })
    }
    importData(e) {
        var startDate = this.state.startDate;
        var endDate = this.state.endDate;
        var today = new Date();
        today.setHours(0,0,0,0);

        if (startDate=="") {
          this.handleNotificationClick("tr", 3, "Please Select Eligible From");
          return false;
        }
        if (endDate=="") {
          this.handleNotificationClick("tr", 3, "Please Select Eligible To");
          return false;
        }
        if ((Date.parse(startDate) < Date.parse(today))) {
          this.handleNotificationClick("tr", 3, "Eligible From should be greater than or equal to today");
          return false;
        }
        if ((Date.parse(endDate) <= Date.parse(startDate))) {
          this.handleNotificationClick("tr", 3, "Eligible To should be greater than Eligible From");
          return false;
        }
        if (this.state.visitType=="") {
          this.handleNotificationClick("tr", 3, "Please select Visit Type");
          return false;
        }
        if (this.state.no_of_visits=="") {
          this.handleNotificationClick("tr", 3, "Please enter No of Visits");
          return false;
        }
        var post_data = this.state.keyValuesDataPost;
        const keyValuesToAdd = {
            "visitType": this.state.visitType,
            "totalVisit": this.state.no_of_visits,
            "fromDate": moment(startDate).format('DD-MM-YYYY'),
            "toDate":  moment(endDate).format('DD-MM-YYYY')
        };
        const newArray = post_data.map(obj => ({
            ...obj, // Create a shallow copy of the object
            ...keyValuesToAdd // Add the new key-value pairs
        }));

        console.log(newArray);
        var postData = newArray;
        this.processJsonArray(postData);
        console.log(postData);

    }
     processJsonArray = async (postData) => {
        var batchTotal = postData.length/this.state.batchSize;
        batchTotal = Math.ceil(batchTotal)
        console.log("batchTotal",batchTotal);
        this.setState({
            batchEnd: batchTotal,
            api_report:[]
        })
        var count = 0;

        for (let i = 0; i < postData.length; i += this.state.batchSize) {
          count++;
          console.log("count",count);
          this.setState({
            batchStart:count
          })
          const batch = postData.slice(i, i + this.state.batchSize);
          await this.callApiWithBatch(batch); // Wait for the API call to complete before moving to the next batch

        }
     };
      // Function to call the API with a batch of items
      callApiWithBatch = async (batch) => {
        this.setState({
            isDisable: true,
            show_text: 'Processing',
            show_count: true,
            loading1:true
        })
        try {
          // Replace 'apiEndpoint' with your actual API endpoint
          const response = await axios.post(config.get('API_URL')+'/tableau/submit-action-console/', batch, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
          });

          // Handle the API response data here
          console.log('API Response:', response.data);
          if(response.data.success){

              this.setState(prevState => ({
                api_report: [...prevState.api_report, ...response.data.data], // Update the state with the accumulated data
              }));
          }

          if(this.state.batchStart==this.state.batchEnd){
             var res_status = 'Success';
             this.state.api_report.map((st, index) => {
                if(st.success==false || st.success=='false')
                {
                    res_status = 'Failed';
                }
             });
             this.setState({
                res_status:res_status
             })
             console.log("matchcondition");
             var isMsg = false;
             var api_status = 'Success '
             if(response.data.error) {
                isMsg = false;
                api_status = 'Error '
             }
             else {
                isMsg = true;
                api_status = 'Success '
             }
             this.setState({
                isDisable: false,
                loading1:false,
                show_text: 'Completed',
                isMsg: isMsg,
                api_status: api_status
             })

                this.handleNotificationClick("tr", 1, response.data.message);

          }
        } catch (error) {
          // Handle API errors here
          console.error('API Error:', error);
          this.setState({
                isDisable: false,
                loading1:false,
                show_text: 'Completed',
                api_status: 'Error'
             })
        }
      };

       handleFromChange = date => {
//         alert(date);
//         var aa = moment(date).format('YYYY-MM-DD')
//         alert(aa);

        this.setState({
            startDate: date
        });
    };

    handleToChange = date => {
        this.setState({
            endDate: date
        });
    };
    changeVisitType(e){
        this.setState({
            visitType:e.target.value
        })
    }
    changeNoOfVisit(e){
        this.setState({
            no_of_visits:e.target.value
        })
    }
    download_campaign(e) {
        const csv1 = convertToCSV(this.state.campaign_data);
        const filename1 = 'marketing_communication.csv';
        downloadCSV(csv1, filename1);
    }
    download_action_data(e) {
        const csv2 = convertToCSV(this.state.api_report);
        const filename2 = 'report.csv';
        downloadCSV(csv2, filename2);
    }
    handleFirstInteractive = () => {
        this.viz.addEventListener(
          tableau.TableauEventName.MARKS_SELECTION,
          this.handleMarksSelection
        );

  };

  handleMarksSelection = (event) => {
    const worksheetName = event.getWorksheet().getName();
    const selectedMarks = event.getMarksAsync().then((marksArray) => {
      this.setState((prevState) => ({
        selectedMarksData: {
          ...prevState.selectedMarksData,
          [worksheetName]: marksArray,
        },
      }));
    });
  };

  generateSelectedMarksText = () => {
    const { selectedMarksData } = this.state;
    let allSelectedMarksText = '';

    for (const [sheetName, marksArray] of Object.entries(selectedMarksData)) {
      //allSelectedMarksText += `${sheetName}:\n`;
      console.log(marksArray.length);
      if(marksArray.length > 0) {
        var marksDataArray = marksArray[0].getPairs();
        console.log(marksDataArray);
        if(sheetName=='Source-Destination'){
            marksDataArray = [...marksDataArray].reverse();
           // marksDataArray.splice(2, 1);
        }
//         if(sheetName=='Pareto'){
//             var marksDataArray1 = marksArray[0].getPairs();
//             marksDataArray = marksDataArray1.splice(0, 1);
//         }
//         if(sheetName=='Organization Trend'){
//             var marksDataArray2 = marksArray[0].getPairs();
//             marksDataArray = marksDataArray2.splice(0, 1);
//         }
        if(sheetName=='Visits Trend'){
             marksDataArray = [...marksDataArray].reverse();
            //marksDataArray = marksDataArray3.splice(0, 1);
        }

        marksDataArray.map((pair, colIndex) => {
        if(pair.fieldName == 'Source' || pair.fieldName == 'Destination' || pair.fieldName == 'lounge_name' || pair.fieldName == 'Name (Member Organizations)' || pair.fieldName == 'Name (Member Organizations)' || pair.fieldName == 'Measure Names' || pair.fieldName == 'MONTH(Created At)' || pair.fieldName == 'Visits') {
            allSelectedMarksText += `${this.replaceFieldName(pair.fieldName)}: ${pair.formattedValue}, `;
          }
        })

      }


      allSelectedMarksText += '\n';
    }
    allSelectedMarksText = allSelectedMarksText.trim(); // Remove any trailing whitespace
    if (allSelectedMarksText.endsWith(',')) {
        allSelectedMarksText = allSelectedMarksText.slice(0, -1); // Remove the trailing comma
    }
    return allSelectedMarksText;
  };
  replaceFieldName = (originalFieldName) => {
    // Replace field names with custom names as needed
    if (originalFieldName === 'lounge_name') {
      return 'Lounge name';
    } else if (originalFieldName === 'Name (Member Organizations)') {
      return 'Organization';
      }
      else if (originalFieldName === 'Measure Names') {
      return 'Visit Type';
      }
      else if (originalFieldName === 'MONTH(Created At)') {
      return 'Month';
      }

    // Return the original field name if not replaced
    return originalFieldName;
  };
  get_visit_type(){
         axios.post(config.get('API_URL')+'/tableau/get-visit-type/',
         {
            id:""
         },
         {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {
            console.log("ffffff",response.data);
            this.setState({
                visit_type_lists: response.data.data
            })
        }).catch( err => {
            console.log(err);
        });
    }
    render() {
    const allSelectedMarksText = this.generateSelectedMarksText();
    const { selectedMarksData } = this.state;
    if(this.state.loggedIn === false){
      //return <Redirect to ="/admin/login"/>
       window.location.href = "/";
    }

        console.log(this.state.api_report);
        console.log("underlyingData state")
        console.log(this.state.underlyingData);
        var stdate = this.state.startDate;

        var endate = this.state.endDate;

        let cardLists = this.state.underlyingData.map((underlying_data, index) => {
            var nm = "";
            if(underlying_data["Mobile Number"]!=""){
                const firstDigit = underlying_data["Mobile Number"].charAt(0);
                const secDigit = underlying_data["Mobile Number"].charAt(1);
                nm = firstDigit+secDigit+"xxxx"+underlying_data["Mobile Number"].substr(-4);
            }
            return (
                <li key={index + 1}>{nm}</li>
            )
        });
        let visitTypes = this.state.visit_type_lists.map((visit, index) => {
            return (
                <option value={visit.id} key={index + 1}>{visit.type}</option>
            )
        });
        let workbookUrl = "/admin/lounge-workbook/"+this.state.workbook_kpi_id;
        let worksheetUrl = "/admin/lounge-view/"+this.state.worksheet_kpi_id;
        let reportUrl = this.state.tableau_server_url+"/trusted/"+this.state.tableau_token+this.state.tableau_report_link+"?:embed=yes";
        return(
            <div className="content-invoice">
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    element={document}
                    onActive={this.onActive}
                    onIdle={this.onIdle}
                    onAction={this.onAction}
                    debounce={250}
                    timeout={1000 * 60 * 30} />
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="">
                                <div className="content">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="card title-card-bottom-space">
                                            <nav aria-label="breadcrumb">
                                                    <ol className="breadcrumb">
                                                        <li className="breadcrumb-item">
                                                            <Link className="" to="/admin/lounge-project/" >Project</Link>
                                                        </li>
                                                        <li class="breadcrumb-item">
                                                            <Link className="" to={worksheetUrl} >{this.state.workbook_name}</Link>
                                                        </li>
{/*                                                         <li class="breadcrumb-item"> */}
{/*                                                             <Link className="" to={worksheetUrl} >{this.state.worksheet_name}</Link> */}
{/*                                                         </li> */}

                                                        <li aria-current="page" class="breadcrumb-item active">{this.state.tableau_report_name}</li>
                                                        <div className="col-md-4 pull-right">
                                                            <button type="button" className="btn btn-primary" role="button" onClick={this.getUnderlyingData.bind(this)}>
                                                                <i className="fa fa-download" aria-hidden="true"></i>&nbsp;Export
                                                            </button> &nbsp;&nbsp;
                                                            <button type="button" className="btn btn-primary" role="button" onClick={this.toggleNewUserUpload.bind(this, 'Add')}>
                                                                Action Console
                                                            </button>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </ol>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*<div className="header">*/}
                                {/*    <h4 className="title">Transaction</h4>*/}
                                {/*    <p className="category"></p>*/}
                                {/*</div>*/}
                                <div className="row">
                                  <BeatLoader
                                      css={override}
                                      sizeUnit={"px"}
                                      size={15}
                                      color={'#123abc'}
                                      loading={this.state.loading}
                                  />
                                    <div className="col-md-12 tableauEmbed">
                                    {this.state.loading===false && this.state.token_error===false?
                                         <div id="tableauViz"></div>:null}
                                    </div>
                                </div>
                                <div className="col-md-12 userModelBox">
                                   <ModalD visible={this.state.user_upload} width="75%" height="100%" effect="fadeInUp">
                                      <div className="">
                                         <div className="">
                                            <div className="modal-header">
                                               <div className="col-md-6"> Action Console</div>
                                               <div className="col-md-1 pull-right">
                                                  <a href="javascript:void(0);" onClick={() => this.closeUploadModal()}>
                                                  <i className="fa fa-times-circle" aria-hidden="true"></i>
                                                  </a>
                                               </div>
                                               <div className="clearfix"></div>
                                            </div>
                                         </div>
                                         <div className="">
                                            <div className="col-md-3 card-con">
                                               <h6>List of Mobile Numbers</h6>
                                               <div className="cardLists">
                                                  <ul>{cardLists}

                                                  </ul>
                                               </div>
                                            </div>
                                            <div className="col-sm-9 action-console">
                                               <div className="col-md-12">
                                                  <h6>Filter Applied</h6>
                                                  <p>{allSelectedMarksText}
                                                  {allSelectedMarksText==''? this.state.customers_count+ ' '+this.state.customers_se+'.'
                                                  :' ('+this.state.customers_count+ ' '+this.state.customers_se+').'}</p>
                                                  <button type="button" className="btn btn-primary" role="button"  onClick={this.ChangeEligibility.bind(this)}>Change Eligibility</button>
                                               {this.state.showForm===true?   <hr/>: null }
                                               </div>
                                               {this.state.showForm===true?
                                               <div>
                                               <div className="col-md-6 ">
                                                  <div className="form-group">
                                                     <label htmlFor="queryName" className="">Eligible From</label>
                                                        <DatePicker
                                                            dateFormat="d MMM yyyy"
                                                            selected={Date.parse(this.state.startDate)}
                                                            onChange={this.handleFromChange}
                                                        />
{/*                                                      <input  value= "31 Jul 2023" placeholder= "31 Jul 2023" type="text" name="file" className="form-control" onChange={this.changeVal} /> */}
                                                  </div>
                                               </div>
                                               <div className="col-md-6 ">
                                                  <div className="form-group">
                                                     <label htmlFor="queryName" className="">Eligible To</label>
                                                         <DatePicker
                                                            dateFormat="d MMM yyyy"
                                                            selected={Date.parse(this.state.endDate)}
                                                            onChange={this.handleToChange}
                                                        />
{/*                                                      <input value= "31 Sep 2023" placeholder= "31 Sep 2023" type="text" name="fileDoc" className="form-control" onChange={this.changeVal} /> */}
                                                  </div>
                                               </div>
                                               <div className="col-md-6 ">
                                                  <div className="form-group">
                                                     <label htmlFor="queryName" className="">Visit Type</label>
                                                     <select name="visitType" className="form-control"
                                                        value={this.state.visitType}
                                                        onChange={this.changeVisitType.bind(this)}
                                                        >
                                                         <option value="">Select Visit Type</option>
                                                          <option value="1">complimentary</option>
                                                           <option value="2">Reward</option>

{/*                                                      {visitTypes} */}

                                                     </select>
                                                  </div>
                                               </div>
                                               <div className="col-md-6 ">
                                                  <div className="form-group">
                                                     <label htmlFor="queryName" className="">No of Visits</label>
                                                     <input type="text" value= {this.state.no_of_visits} placeholder= "7" name="no_of_visits" className="form-control" onChange={this.changeNoOfVisit.bind(this)} />
                                                  </div>
                                               </div>
                                               <div className="col-md-6 ">
                                                  <button type="button" className="btn btn-primary" role="button"  onClick={this.importData.bind(this)} disabled={this.state.isDisable}>Submit</button>
                                               </div>
                                               <div className="col-md-6 pull-right">
                                                    {this.state.show_count===true?
                                                       <div>{this.state.show_text} {this.state.batchStart}  of {this.state.batchEnd}</div>:null
                                                    }
                                                </div>
                                                <BeatLoader
                                                    css={override}
                                                    sizeUnit={"px"}
                                                    size={15}
                                                    color={'#123abc'}
                                                    loading={this.state.loading1}
                                                />
                                               <div className="clearfix"></div>
                                               </div>:null}

                                              {this.state.isMsg===true?
                                               <div className="col-md-12 success-msg-lo">
                                                  <hr/>
                                                  <p>The following lounge visit eligibility changes have been made to the selected member profiles:</p>
                                                  <div className="msg-table">
                                                     <table border = "1">
                                                        <thead>
                                                        <tr>
                                                           <th># Members</th>
                                                           <th>Eligible from</th>
                                                           <th>Eligible to</th>
                                                           <th>Visit Type</th>
                                                           <th>No of Visits</th>
                                                           <th>Status</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr>
                                                           <td>{this.state.customers_count}</td>
                                                           <td>{moment(stdate).format('D MMM YYYY')}</td>
                                                           <td>{moment(endate).format('D MMM YYYY')}</td>
                                                           <td>{this.state.visitType}</td>
                                                           <td>{this.state.no_of_visits}</td>
                                                           <td>{this.state.res_status=='Success'?<span>Success <i class="fa fa-check-circle" aria-hidden="true"></i></span>
                                                            :<span>Failed</span>}
                                                            &nbsp;
                                                           <a href="#" onClick={this.download_action_data.bind(this)}> - Download Details</a>
                                                           </td>
                                                        </tr>
                                                        </tbody>
                                                     </table>
                                                  </div>
                                                  <br/>
                                                  {/*
                                                  <div><label><b>Eligible from:</b> 31 Jul 2023</label> </div>
                                                  */}
                                                  {/*
                                                  <div><label><b>Eligible to:</b> 31 Sep 2023</label> </div>
                                                  */}
                                                  {/*
                                                  <div><label> <b>Visit Type:</b> Additional Visits</label> </div>
                                                  */}
                                                  {/*
                                                  <div><label> <b>No of Visits:</b> 7 </label> </div>
                                                  */}
                                                  <div className="download-m-file"><a href="#" onClick={this.download_campaign.bind(this)}>Download Marketing Communication File</a></div>
                                               </div>:null}
                                            </div>
                                            <div className="clearfix"></div>
                                         </div>
                                      </div>
                                   </ModalD>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(LoungeReportAPIQA);